import { LAYERFILE} from './LayerFileTypes'
const initialState = {
    layerFile: null
}

const addLayerFile = (state = initialState, action) => {
    
    switch (action.type) {
        case LAYERFILE:
            
            return {
                layerFile: action.load
            }
    
        default:
          return state
    }

}


export default addLayerFile;